export enum ComplaintStatus {
  Capture = 0,
  Acknowledge = 3,
  Categorize = 6,
  Investigate = 9,
  Escalate = 12,
  Resolve = 15,
  Close = 18
}

export const ComplaintStatusLabels: Record<ComplaintStatus, string> = {
  [ComplaintStatus.Capture]: 'Capture',
  [ComplaintStatus.Acknowledge]: 'Acknowledge',
  [ComplaintStatus.Categorize]: 'Categorize',
  [ComplaintStatus.Investigate]: 'Investigate',
  [ComplaintStatus.Escalate]: 'Escalate',
  [ComplaintStatus.Resolve]: 'Resolve',
  [ComplaintStatus.Close]: 'Close'
};

export function getComplaintStatusLabel(status: ComplaintStatus | number | string): string {
  const statusNum = typeof status === 'string' ? parseInt(status, 10) : status;
  return ComplaintStatusLabels[statusNum as ComplaintStatus] || 'Unknown';
}
